var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.585,
    height: 56.547,
    viewBox: "0 0 132.585 56.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#fe5000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#fd421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#fd313d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fd2457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#fd1b6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#fd1576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#fd147a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077",
    transform: "translate(-463.918 -366.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M499.405,406.441c0,10.234-7.086,16.775-16.23,16.775-4.058,0-7.388-1.272-9.81-3.936v15.2h-9.447V390.151h9.023v3.754c2.362-2.846,5.874-4.239,10.234-4.239C492.32,389.667,499.405,396.207,499.405,406.441Zm-9.569,0c0-5.632-3.573-9.023-8.3-9.023s-8.3,3.391-8.3,9.023,3.573,9.023,8.3,9.023S489.837,412.073,489.837,406.441Z",
    transform: "translate(0 -11.518)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M666.55,409.106H641.9c.908,4.057,4.36,6.54,9.326,6.54A11.043,11.043,0,0,0,659.4,412.5l5.027,5.451c-3.028,3.451-7.57,5.268-13.443,5.268-11.264,0-18.592-7.086-18.592-16.775,0-9.75,7.448-16.774,17.38-16.774,9.568,0,16.956,6.419,16.956,16.9C666.731,407.289,666.61,408.319,666.55,409.106Zm-24.768-5.511h16.048a8.138,8.138,0,0,0-16.048,0Z",
    transform: "translate(-83.452 -11.518)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M707.914,366.415h9.447v44.8h-9.447Z",
    transform: "translate(-120.858 0)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M582.691,398.308l-5.577-7.681h-10.6l10.9,14.552Z",
    transform: "translate(-50.82 -11.993)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M588.628,406.553l12.112-15.927H590.687l-25.011,32.58h10.295l7.388-9.992,7.146,9.992h10.719Z",
    transform: "translate(-50.404 -11.993)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M541.716,390.627h9.447v32.58h-9.447Z",
    transform: "translate(-38.536 -11.993)",
    fill: "#201747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    "data-name": "Rectangle 1908",
    width: 9.447,
    height: 9.447,
    transform: "translate(503.18 366.415)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelLogo);
export default __webpack_public_path__ + "static/media/pixel-logo.8a8ba20c01fdfe4eba121f2c0817908d.svg";
export { ForwardRef as ReactComponent };